export const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="relative w-12 h-12">
      {/* Arc gradient orange→fuschia qui tourne */}
      <div
        className="absolute inset-0 rounded-full bg-gradient-orange-fuschia-vertical"
        style={{
          WebkitMask:
            'radial-gradient(farthest-side, transparent calc(101% - 8px), white calc(101% - 8px))',
          mask: 'radial-gradient(farthest-side, transparent calc(101% - 8px), white calc(101% - 8px))',
        }}
      />
      {/* Cercle de fond gris (track) */}
      <div
        className="absolute inset-0 rounded-full border-8 animate-spin border-black-200 border-t-transparent"
        style={{
          WebkitMask:
            'radial-gradient(farthest-side, transparent calc(100% - 8px), white calc(100% - 8px))',
          mask: 'radial-gradient(farthest-side, transparent calc(100% - 8px), white calc(100% - 8px))',
        }}
      />
    </div>
  </div>
)
